export default {
  'pagination': {'next': 'Next &raquo;', 'previous': '&laquo; Previous'},
  'This project is locked by: {0}': 'This project is locked by: {0}}',
    "file_to_large": "{fileName} may be a maximum of {size}!",
    "file_to_large_aggregate": "The sum of the size of all files must not exceed {size}!",
    "max_file_amount": "Maximum {amount} files are allowed to be uploaded at the same time!"
};
